export function initHeroScroll() {
  document.querySelectorAll(".hero__scroll").forEach((button) => {
    button.addEventListener("click", () => {
      button.closest(".hero")?.nextElementSibling?.scrollIntoView({ behavior: "smooth" });
    });
  });
}
